import { HostListener, Component, AfterContentChecked, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum, StatusEnum } from '../shared/enums.model';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { MultiPartService } from './multipart-part.service';
import { UserHandling } from '../shared/user-handling';
import { ConfirmResult } from '../../app/dialogboxes/shared/confirm.model'
import { InputTimerAction } from '../shared/input-timer-action';
import { MultiPartBE } from './shared/multipart-part.model';
import { SetFocus } from '../../app/shared/setFocus';
import { PartSupplierPruService } from '../partsupplierpru/partsupplierpru.service';
import { PartListBE } from '../partsupplierpru/shared/partsupplierpru.model';
import { ChineseChangeValueService } from '../chinese-change-value.service';

@Component({
    moduleId: module.id,
    selector: 'multipart-part',
    templateUrl: 'multipart-part.html',
    providers: [MultiPartService, PartSupplierPruService],
})
export class MultiPartComponent implements AfterContentChecked, ComponentCanDeactivate {
    showSpinner: boolean = false;

    searchKeyStrokeDelay: number = 350;
    searchListDelayTimerDelay: number = 250;

    // main part search
    viewMainPartListSpinner: boolean = false;
    mainPartSearchListDelayTimer: any = null;
    searchMainPartText: string = "";
    viewMainPartList: boolean = false;
    typeDelayTimer: any = null;
    selectedMainPart: PartListBE = null;
    searchMainPartsList: PartListBE[] = null
    
  
    // consisting part text handling
    viewConsisitingPartsListSpinner: boolean = false;
    addConsistingPartText: string = "";
    consistsOfPartsList: PartListBE[] = null

    // confirm dialog
    @ViewChild('cDlg') cdlg: ElementRef;
    dialogAction: string;
    dialogBtnType: string;
    dialogAppliesTo: string = "";
    dialogAppliesToId: number = -1;
    currentDlg: NgbModalRef;

    // misc
    user: UserHandling = new UserHandling();
    isDirty: boolean = false;

    setFocus: SetFocus = new SetFocus();
    isFocusSet: boolean = false;

    constructor(
        private partSupplierPruService: PartSupplierPruService,
        private multiPartService: MultiPartService,
        private modalService: NgbModal,
        private errHandler: ErrorHandlerService,
        private ChineseChangeValueService:ChineseChangeValueService
    ) {}
     
    ngAfterContentChecked() {
        this.isFocusSet = this.setFocus.to("searchPart", this.isFocusSet);
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return !this.isDirty;
    }

    // ----------------------------------------------------------
    // Fetch list data
    // ----------------------------------------------------------
    loadPartList() {
        this.searchMainPartsList = [];
        this.viewMainPartListSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
        this.partSupplierPruService.searchPart(this.searchMainPartText, false)
            .subscribe(returnObject => this.loadPartListResponse(returnObject));
    }

    loadPartListResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'MultiPartComponent.loadPartListResponse', returnObject.ErrorType);
        else 
            this.searchMainPartsList = returnObject.DataList;

        this.viewMainPartListSpinner = false;
    }

    loadExistingConsistingParts(partNo: string) {
        this.viewConsisitingPartsListSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
        this.multiPartService.getConsistingPartsForPart(partNo)
            .subscribe(returnObject => this.loadExistingConsistingPartsResponse(returnObject));
    }

    loadExistingConsistingPartsResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'MultiPartComponent.loadExistingConsistingPartsResponse', returnObject.ErrorType);
        else
            this.consistsOfPartsList = returnObject.DataList;

        this.viewConsisitingPartsListSpinner = false;
        this.isFocusSet = this.setFocus.to("consisitingPartText", false);        
    }


    // ----------------------------------------------------------
    // Actions
    // ----------------------------------------------------------
    delete() {
        this.openConfirmDeleteDlg();
    }

    doDelete() {
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.multiPartService.deleteMultiPart(this.selectedMainPart.Id)
            .subscribe(returnObject => this.deleteResponse(returnObject));
    }

    deleteResponse(returnObject: IReturnObject) {
        this.showSpinner = false;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'MultiPartComponent.deleteResponse', returnObject.ErrorType);
        }
        else{
            this.searchMainPartText = "";
            this.selectedMainPart = null;
            this.isDirty = false;
        }
    }

    update() {
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);

        let part: MultiPartBE = new MultiPartBE();
        part.MainPartId = this.selectedMainPart.Id;
        part.PartNo = this.selectedMainPart.PartNo;
        this.consistsOfPartsList.forEach(element => {
            part.ContainingParts.push(element);
        });
        
        this.multiPartService.updateMultiPart(part)
            .subscribe(returnObject => this.updateResponse(returnObject));
    }

    updateResponse(returnObject: IReturnObject) {
        this.showSpinner = false;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'MultiPartComponent.updateResponse', returnObject.ErrorType);
        }
        else {
            this.consistsOfPartsList = returnObject.DataList;
            this.isDirty = false;
        }        
    }


    // ----------------------------------------------------------
    // Dialog boxes
    // ----------------------------------------------------------
    openConfirmDeleteDlg() {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "delete";
        this.dialogBtnType = "danger";
        this.dialogAppliesTo = "Composition part";
        this.dialogAppliesToId = this.selectedMainPart.Id;
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
    }

    onConfirmDlgNotify(command: ConfirmResult): void {
        this.closeDlg();
        if (command.Action == "delete") {
            this.doDelete();
        }
    }

    closeDlg() {
        this.currentDlg.close();
    }


    // ----------------------------------------------------------
    // Search main part
    // ----------------------------------------------------------
    searchMainPartTextChanged() {
        var that = this; // needed to preserve scope reference to this within setinterval function

        if (that.searchMainPartText.length >= 2) {
            that.viewMainPartList = true;

            // If this.typeDelayTimer is not nulll then the  
            // user typed somthing new within time limit so reset timer
            if (that.typeDelayTimer != null)
                clearInterval(that.typeDelayTimer);

            that.typeDelayTimer = setInterval(function () {
                that.loadPartList();
            }, that.searchKeyStrokeDelay);
        }
        else {
            that.viewMainPartList = false;
            clearInterval(this.typeDelayTimer);
        }
    }

    startMainPartSearchListWithDelay() {
        var that = this;

        if (!that.viewMainPartList) {
            clearInterval(this.mainPartSearchListDelayTimer);
            return;
        }

        if (that.mainPartSearchListDelayTimer != null)
            clearInterval(that.mainPartSearchListDelayTimer);

        that.mainPartSearchListDelayTimer = setInterval(function () {
            that.finalizeHideMainPartSearchListWithDelay();
        }, that.searchListDelayTimerDelay);
    }

    finalizeHideMainPartSearchListWithDelay() {
        this.viewMainPartList = false;
        clearInterval(this.mainPartSearchListDelayTimer);
    }

    hideMainPartSearchListWithDelay() {
        clearInterval(this.mainPartSearchListDelayTimer);
        this.startMainPartSearchListWithDelay();
    }

    showMainPartSearchList() {
        if (this.searchMainPartText.length >= 2) {
            clearInterval(this.mainPartSearchListDelayTimer);
            this.viewMainPartList = true;
        }
    }

    selectMainPart(part: PartListBE) {
        if (this.selectedMainPart == null || part.PartNo != this.selectedMainPart.PartNo){
            this.selectedMainPart = part;
            this.consistsOfPartsList = [];
        }

        if (this.selectedMainPart.IsMultiPart)
            this.loadExistingConsistingParts(this.selectedMainPart.PartNo)

        clearInterval(this.mainPartSearchListDelayTimer);
        this.hideMainPartSearchListWithDelay();
    }


    // ----------------------------------------------------------
    // Add delete consisting part
    // ----------------------------------------------------------
    isNewConsistingPartButtonDisabled() {
        return this.addConsistingPartText.length == 0;
    }

    addConsistingPart() {
        let newSelection: PartListBE = new PartListBE();
        newSelection.Description = this.addConsistingPartText;
        newSelection.Quantity = 1;
        this.consistsOfPartsList.push( newSelection);
        this.addConsistingPartText = "";
        this.isFocusSet = this.setFocus.to("consisitingPartText", false);        
        this.setDirty();
    }

    removeConsistingPart(partId: number) {
        let inx: number = this.consistsOfPartsList.findIndex(x => x.Id == partId);
        this.consistsOfPartsList.splice(inx, 1);
        this.setDirty();
    }


    // ----------------------------------------------------------
    // MISC
    // ----------------------------------------------------------
    setDirty() {
        this.isDirty = true;
    }

    isUpdateDisabled(): boolean {
        let isDisabled: boolean = !this.isDirty
            && this.selectedMainPart == null;

        return isDisabled;
    }

    isDeleteDisabled() {
        return this.selectedMainPart == null;
    }

    // ------------------------------------------------------
    //Access rights control
    // ------------------------------------------------------
    isPageAccessible(): boolean {
        return (this.user.IsPackagingAdmin
            || this.user.IsPackagingEngineer
            || this.user.IsDeveloper);
    }
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/multipart-part/multipart-part.component.ts